import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Interview from "@/components/Interview";
import InterviewSummary from "@/components/InterviewSummary";
import Success from "@/components/Success";
import Preview from "@/components/Preview";
import AlternateEnding from "@/components/alternate_endings/AlternateEnding";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      name: "home-no-keyword",
      props: true,
      component: Home
    },
    {
      path: "/:keyword",
      name: "home",
      props: true,
      component: Home
    },
    {
      path: "/:keyword/r/:referrer",
      name: "home-with-referrer",
      props: true,
      component: Home
    },
    {
      path: "/:keyword/p/:patient",
      name: "home-with-patient",
      props: true,
      component: Home
    },
    // {
    //   path: "/:keyword/interview/:p/:q",
    //   name: "interview",
    //   props: true,
    //   component: Interview,
    // },
    {
      path: "/:keyword/interview/:id/:p/:q",
      name: "interview",
      props: true,
      component: Interview
    },
    {
      path: "/:keyword/:id/summary",
      name: "summary",
      props: true,
      component: InterviewSummary
    },
    {
      path: "/:keyword/:id/success",
      name: "success",
      props: true,
      component: Success
    },
    {
      path: "/:keyword/:id/done",
      name: "alternate-ending",
      props: true,
      component: AlternateEnding
    },
    {
      path: "/preview/:id",
      name: "preview",
      props: true,
      component: Preview
    },
    {
      // catch any 404 paths
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log("to=", to);
  let toName = to.name;
  // console.log("from=", from);
  let fromName = from.name;

  if (toName == "home" && fromName != null) {
    setTimeout(function() {
      window.location.reload();
    }, 1);
  }

  next();
});

export default router;
